import { writable } from 'svelte/store'
import {Region, UserPoolId, ClientId} from "./cognito-config";
import {AuthenticationDetails, CognitoUser, CognitoUserAttribute, CognitoUserPool} from "amazon-cognito-identity-js";
import {push} from "svelte-spa-router";

const { subscribe, set, update } = writable(localStorage.getItem("kulrs-user") || "")

const poolData = {
    Region,
    UserPoolId,
    ClientId
};
const userPool = new CognitoUserPool(poolData);
if (typeof AWSCognito !== 'undefined') {
    AWSCognito.config.region = poolData.region;
}

function signOut() {
    if(user){
        if (user['id-service'] === 'cognito'){
            userPool.getCurrentUser().signOut();
        }
    }
    update(u => "");
    localStorage.removeItem('kulrs-user');
    push('/');
}

async function signinSuccess() {
    console.log('Successfully Logged In');
    await authToken().then(() => push('/'));
}

function signIn(email, password, failureCallBack) {
    const authenticationDetails = new AuthenticationDetails({
        Username: toUsername(email),
        Password: password
    });

    const cognitoUser = createCognitoUser(email);
    cognitoUser.authenticateUser(authenticationDetails, {
        onSuccess: signinSuccess,
        onFailure: failureCallBack
    });
}

function registerSuccess(result) {
    let cognitoUser = result.user;
    console.log('userToken name is ' + cognitoUser.getUsername());
    const confirmation = ('Registration successful. Please check your email inbox or spam folder for your verification code.');
    if (confirmation) {
        push('/verify');
    }
}

function register(email, password, onFailure) {
    const dataEmail = {
        Name: 'email',
        Value: email
    };
    const attributeEmail = new CognitoUserAttribute(dataEmail);
    userPool.signUp(toUsername(email), password, [attributeEmail], null,
        function signUpCallback(err, result) {
            if (!err) {
                registerSuccess(result);
            } else {
                onFailure(err);
            }
        }
    );
}

function verify(email, codeInputVerify, callback) {
    createCognitoUser(email).confirmRegistration(codeInputVerify, true, callback);
}

function createCognitoUser(email) {
    return new CognitoUser({
        Username: toUsername(email),
        Pool: userPool
    })
}

function toUsername(email) {
    return email.replace('@', '-at-');
}

function extractUserDetails(cognitoUser){
    cognitoUser.getUserAttributes(function(err, result) {
        if (err) {
            console.log(err.message || JSON.stringify(err));
            update(u => null);
            return;
        }
        let profile = {}
        profile['id-service'] = "cognito"
        for (let i = 0; i < result.length; i++) {
            profile[result[i].getName()] = result[i].getValue();
            console.log(
                'attribute ' + result[i].getName() + ' has value ' + result[i].getValue()
            );
        }
        update(u => profile);
    })
}

function sessionCallback(err, session, cognitoUser) {
    if (err) {
        throw err;
    } else if (!session.isValid()) {
        return null;
    } else {
        extractUserDetails(cognitoUser);
        return(session.getIdToken().getJwtToken());
    }
}

function dealWithGoogleMcGoober(token){
    // let payload = token.split('.')[1];
    // payload = JSON.parse(atob(payload));
    // console.log(payload)
    let payload = token
    // console.log('email: ' + payload['email'])
    // let username = 'google_' + payload['sub'];

    let profile = {}
    profile['id-service'] = "google"
    // profile['username'] = username

    for (let i = 0; i < payload.length; i++) {
        profile[payload[i].getName()] = payload[i].getValue();
    }

    update(u => profile);

    // return username;
}

async function authToken() {
    return await new Promise(function fetchCurrentAuthToken(resolve, reject) {
        const cognitoUser = userPool.getCurrentUser();
        if (cognitoUser) {
            cognitoUser.getSession((err, session) => sessionCallback(err, session, cognitoUser));
            resolve();
        } else {
            resolve();
        }
    })
}

subscribe(val => localStorage.setItem("kulrs-user", val));

export const user = {
    subscribe,
    authToken,
    signIn,
    register,
    verify,
    dealWithGoogleMcGoober,
    signOut
}

